import Vue from 'vue';

import '@/plugins/vuelidate';
import { BootstrapVue } from "bootstrap-vue";
import Element from "element-ui";
import locale from "element-ui/lib/locale";
import lang from "element-ui/lib/locale/lang/pt-br";
import Toaster from 'v-toaster';
// import { VueReCaptcha } from 'vue-recaptcha-v3';
//import VueInputDirectives from '@/directives'


import 'animate.css';
import animated from 'animate.css';
import "bootstrap-vue/dist/bootstrap-vue.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "element-ui/lib/theme-chalk/index.css";
import 'v-toaster/dist/v-toaster.css';

import axios from 'axios';
import moment from 'moment';
import App from './App';
import router from './router';

//

Vue.prototype.moment = moment;
Vue.prototype.$http = axios
// Vue.prototype.urlAPI = 'http://127.0.0.1:8000/api/' // url do webservice
Vue.prototype.urlAPI = 'https://www.maria-bailarina.com/public/api/'

// configure language
locale.use(lang);
Vue.use(BootstrapVue);
Vue.use(Element);
Vue.use(Toaster, {timeout: 5000});
Vue.use(animated);
// Vue.use(VueReCaptcha, { siteKey: '6LeeEr8qAAAAAJtufHgmkLCEB7L7HBxjAutk2Vxf' })

//Vue.use((VueInputDirectives))


Vue.directive("scroll", {
  inserted: function(el, binding) {
    let f = function(evt) {
      if (binding.value(evt, el)) {
        window.removeEventListener("scroll", f);
      }
    };
    window.addEventListener("scroll", f);
  }
});

//Vue.config.productionTip = false
Vue.config.productionTip = true

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js